import {
  IconSizes,
  IIconProps,
} from '@monofront/design-system/visuals/Icons/type';
import { useEditorialSidePanelContext } from '@monofront/business/contexts';

export interface IValueData {
  Badge: React.FC<IIconProps>;
  label: string;
  documentUid?: string;
}

interface IListItemProps {
  valueId: string;
  valueData: IValueData;
  size?: 'md' | 'lg';
  enableSidePanel?: boolean;
  tagColor?: string;
}

const ListItem: React.FC<IListItemProps> = ({
  valueId,
  valueData,
  size = 'md',
  enableSidePanel = false,
  tagColor = 'tw-lf-tag-decorative-blue',
}) => {
  const { setEditorialPanelSourceUid } = useEditorialSidePanelContext();

  const tagClasses = `tw-lf-tag ${
    size === 'lg' ? 'tw-lf-tag-lg' : 'tw-lf-tag-md'
  } ${tagColor}`;
  const badgeSize = size === 'lg' ? IconSizes.lg : IconSizes.md;
  const { Badge, label, documentUid } = valueData;

  const badgeContent = (
    <>
      <Badge size={badgeSize} aria-hidden /> <span>{label}</span>
    </>
  );

  return (
    <li
      className={size === 'lg' ? `tw-mr-3 tw-mt-3` : `tw-mr-2 tw-mt-2`}
      data-testid={`value-tag-${valueId}`}
    >
      {enableSidePanel && documentUid ? (
        <button
          className={`tw-lf-button-clear ${tagClasses}`}
          type="button"
          onClick={() => setEditorialPanelSourceUid(documentUid)}
        >
          {badgeContent}
        </button>
      ) : (
        <p className={tagClasses}>{badgeContent}</p>
      )}
    </li>
  );
};

export default ListItem;
